import React from 'react'

import AssistantGrid from 'components/CompetitiveIntelligence/AssistantGrid'
import CompetitiveIntelligenceHeader from 'components/CompetitiveIntelligence/Header'
import ResearchListSkeleton from 'components/CompetitiveIntelligence/ResearchListSkeleton'
import CompetitiveIntelligenceState from 'components/CompetitiveIntelligence/State'
import useController from './controller'
import { Page } from './styled'

export default function CompetitiveIntelligenceAssistants() {
  const controller = useController()
  return (
    <Page>
      <CompetitiveIntelligenceHeader
        description={controller.t('competitive_intelligence_assistants_description')}
        eyebrow={controller.t('competitive_intelligence_title')}
        t={controller.t}
        title={controller.t('competitive_intelligence_nav_assistants')}
      />
      {controller.status === 'loading' ? (
        <ResearchListSkeleton label={controller.t('competitive_intelligence_assistants_loading')} />
      ) : controller.status === 'ready' ? (
        <AssistantGrid {...controller} />
      ) : (
        <CompetitiveIntelligenceState
          actionLabel={controller.t('try_again')}
          description={controller.t(controller.status === 'denied' ? 'competitive_intelligence_denied_description' : 'competitive_intelligence_assistants_empty_description')}
          onAction={controller.status === 'denied' || controller.status === 'empty' ? undefined : controller.retry}
          title={controller.t(controller.status === 'denied' ? 'competitive_intelligence_denied_title' : 'competitive_intelligence_assistants_empty_title')}
          urgent={controller.status !== 'empty'}
        />
      )}
    </Page>
  )
}
